export const Configuration = 10;
export const PrintNota = 20;
export const PartialPaymentArticle = 30;
export const PartialPaymentAmount = 31;
export const Subtotal = 40;
export const WorkIn = 50;
export const WorkOut = 51;
export const DiscountAmount = 60;
export const DiscountPercentage = 61;
export const DiscountMenu = 62;
export const PriceList = 70;
export const CustomerList = 80;
export const CustomerInfo = 81;
export const TicketInfo = 85;
export const ConfigurationList = 90;
export const ObjectManagementOpen = 100;
export const ObjectManagementClose = 110;
export const ObjectManagementSplit = 120;
export const ObjectManagementSetItemName = 130;
export const ObjectManagementTransfer = 140;
export const ObjectManagementMerge = 150;
export const ManagerLogin = 160;
export const ShowOrders = 170;
export const ParkOrder = 171;
export const ReprintReceipt = 180;
export const FastPayment = 190;
export const ResetCustomer = 200;
export const OverruleAge = 201;
export const ArticleList = 210;
export const ShowKeyLayoutGroup = 220;
export const CancelReceipt = 230;
export const ObjectManagementProcess = 235; // Only a visual function. This function is not stored in the database like others
export const Invoice = 240;
export const PrintInvoice = 241;
export const SetInvoiceReference = 242;
export const CollectReservation = 250;
export const AddBalanceToTicket = 260;
export const CashIn = 280;
export const CashOut = 281;
export const Logout = 300;
export const ResetFiscalPrinter = 330;
export const PrintXReport = 340;
export const PrintZReport = 350;
export const SelectPager = 360;


// WEBPACK FOOTER //
// src/constants/Functions.js